<template>
  <div class="payment">
    <Header :companyInfo="comnpany_info" :showIsok="showOk" />
    <div class="pay common">
      <div class="title">
        <span class="leftBack"></span>
        <span class="text">完成补报避免经营异常和罚款风险</span>
        <span class="rightBack"></span>
      </div>
      <div class="promptBox">
        <div class="select">
          <div class="xinzeng617Box">
            <div class="leftImg"></div>
            <div class="font">代报服务流程</div>
            <div class="rightImg"></div>
          </div>
          <div class="xinzeng617Box3">
            <div class="xinzeng617Box3_xian"></div>
            <div class="xinzeng617Box3_1">
              <div class="xinzeng617Box3_1_top">1</div>
              <div class="xinzeng617Box3_1_bottom">填写信息</div>
            </div>
            <div class="xinzeng617Box3_1">
              <div class="xinzeng617Box3_1_top">2</div>
              <div class="xinzeng617Box3_1_bottom">支付费用</div>
            </div>
            <div class="xinzeng617Box3_1">
              <div class="xinzeng617Box3_1_top">3</div>
              <div class="xinzeng617Box3_1_bottom">代报成功</div>
            </div>
          </div>
          <div class="xinzeng617Box2">
            <img class="xinzeng617Box2_yinying" src="../assets/images/yinying.png" />
            <div class="xinzeng617Box2Left">
              <div class="xinzeng617Box2Left_font1">承诺：</div>
              <div class="xinzeng617Box2Left_font2">年报代办不成功的，会主动退款！</div>
            </div>
            <div class="xinzeng617Box2right"></div>
          </div>
          <div class="xinzeng617Box4">
            <div class="xinzeng617Box4_font">代报年度：</div>
            <!-- {{year_nums}} -->
            <div class="xinzeng617Box4_box">{{ year_nums }}年度</div>
          </div>
          <div class="price">
            <div class="totalPrice">
              <div class="red">
                收费明细：<span style="color: red">{{ this.price }}元</span>&nbsp;
              </div>
              <div v-show="dayuer" class="grey">(99元/年度，多年度优惠)</div>
            </div>
          </div>
          <div class="methods">
            <!-- <span class="text">支付方式：</span> -->
            <div class="wxzfb">
              <div class="wx" @click="payMethods = 1">
                <img alt="" src="../assets/images/wx.png" />
                <span>微信支付</span>
                <div :class="['radio', payMethods == 1 ? 'selectRadio' : '']"></div>
              </div>
              <div class="zfb" @click="payMethods = 2">
                <img alt="" src="../assets/images/zfb.png" />
                <span>支付宝</span>
                <div :class="['radio', payMethods == 2 ? 'selectRadio' : '']"></div>
              </div>
            </div>
          </div>
          <div v-throttle="[pay, `click`, 2000]" class="btn">
            <div class="btn_font">完成支付，补报年报</div>
          </div>
          <div class="agreement" @click="agreement = !agreement">
            <div :class="['radio', agreement == true ? 'selectRadio' : '']"></div>
            <div class="text">
              <span>同意</span>
              <span @click.stop="showProtocol(1)">《企业服务代办服务协议》</span>
              <span>及</span>
              <span @click.stop="showProtocol(2)">《隐私说明》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <contact>
      <span>咨询客服</span>
    </contact> -->
    <div class="enjoy common">
      <div class="title">
        <span class="leftBack"></span>
        <span class="text">选择纽必企服代办 享受快捷服务</span>
        <span class="rightBack"></span>
      </div>
      <div class="differenceBox">
        <div class="difference">
          <div class="left">
            <div class="title2">纽必企服代办</div>
            <div v-for="(item, index) in difference.benefits" :key="index" class="benefits">
              <div>
                <img alt="" src="../assets/images/dui.png" />
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="title2">自己申报办理</div>
            <div v-for="(item, index) in difference.harm" :key="index" class="harm">
              <div>
                <img alt="" src="../assets/images/cuo.png" />
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <kefu />
  </div>
</template>
<script>
import footer from "../components/footer.vue";
import contact from "../components/contact.vue";
import Header from "../components/header2.vue";
import kefu from "../components/kefu.vue";
import { alipay, get_company, get_openid, h5_pay, wx_pay } from "../api/request";
import { MessageBox, Toast } from "mint-ui";

export default {
  name: "", //
  data() {
    return {
      showOk: null,
      dayuer: true,
      year_nums: "",
      comnpany_info: {},
      openid: "",
      payMethods: "1", //支付方式 1微信 2支付宝
      agreement: true, //同意协议
      comnpany_shen: "", //申报列表
      price: "", //支付总价
      unitPrice: 99, //单价
      sbyears: [], //选择申报的年份数组
      difference: {
        benefits: [
          "指导申报内容，流程顺畅合规",
          "专业快捷操作，足不出户完成申报",
          "客服专业服务、快速解决客户问题",
          "纽必企服代办申报，不成功自动退款",
        ],
        harm: [
          "不懂流程，申报费时费力",
          "不熟悉电脑操作，线下送报又不方便",
          "申报内容太多，申报要求难以理解",
          "不懂流程，申报内容多，费时费力还担忧",
        ],
      },
      random: "",
    };
  },
  components: {
    Footer: footer,
    contact,
    Header,
    kefu,
  },
  props: {},
  methods: {
    // 检查客户端
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //判断iPhone|iPad|iPod|iOS
        this.showOk = true;
      } else {
        this.showOk = false;
      }
    },
    //筛选未申报年份，默认未申报全选，price=年数*unitPrice
    get_company() {
      get_company({
        type: 2,
        random: this.random,
      }).then((res) => {
        this.year_nums = res.data.years_str;
        this.comnpany_info = res.data.comnpany_info;
        this.comnpany_shen = res.data.comnpany_shen;
        Object.getOwnPropertyNames(res.data.comnpany_shen).forEach((key) => {
          if (res.data.comnpany_shen[key] == 2 || res.data.comnpany_shen[key] == null) {
            this.sbyears.push(key);
          }
        });
        if (this.sbyears.length == 1) {
          this.price = 99;
          this.dayuer = false;
        } else if (this.sbyears.length == 2) {
          this.price = 178;
        } else if (this.sbyears.length == 0) {
          this.price = 0;
        } else {
          this.price = 252;
        }
      });
    },
    //判断是否为微信内置浏览器
    isWeiXin() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    },
    //支付按钮
    pay() {
      if (this.agreement) {
        if (this.price == 0) {
          Toast("请选择需要申请的年报");
        } else {
          if (this.payMethods == 1) {
            if (this.isWeiXin()) {
              //微信内
              this.wx_pay();
            } else {
              //微信外
              this.h5_pay();
            }
          } else {
            //支付宝
            this.alipay();
          }
        }
      } else {
        Toast("请阅读《年报申报代办服务协议》及《隐私说明》并同意");
      }
    },
    //微信内
    wx_pay() {
      wx_pay({
        openid: this.openid,
        random: this.random,
        price: this.price,
        sbyears: this.sbyears.join(","),
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data.jsApiParameters;
          this.onBridgeReady(data.appId, data.timeStamp, data.nonceStr, data.package, data.signType, data.paySign);
        } else {
          Toast(res.msg);
        }
      });
    },
    onBridgeReady(appId, timeStamp, nonceStr, package1, signType, paySign) {
      let this_ = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, //公众号ID，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: nonceStr, //随机串
          package: package1,
          signType: signType, //微信签名方式：
          paySign: paySign, //微信签名
        },
        function (res) {
          //支付成功
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this_.$router.push({ path: "/orders" });
          }
          // 支付过程中用户取消
          if (res.err_msg == "get_brand_wcpay_request:cancel") {
            Toast("取消支付");
          }
          // 支付失败
          if (res.err_msg == "get_brand_wcpay_request:fail") {
            Toast("支付失败");
          }
        }
      );
    },
    //微信外
    h5_pay() {
      h5_pay({
        random: this.random,
        price: this.price,
        sbyears: this.sbyears.join(","),
        synclink: "https://f8r.cn/orders",
      }).then((res) => {
        if (res.code == 200) {
          window.location.href = res.data.jsApiParameters.h5_url;
        } else {
          Toast(res.msg);
        }
      });
    },
    //支付宝
    alipay() {
      alipay({
        random: this.random,
        price: this.price,
        sbyears: this.sbyears.join(","),
        synclink: "https://f8r.cn/orders",
      }).then((res) => {
        if (res.code == 200) {
          window.location.href = res.data.h5_url;
        } else {
          Toast(res.msg);
        }
      });
    },
    //截取链接code
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    //获取openid
    get_openid(code) {
      get_openid({
        code: code,
      }).then((res) => {
        if (res.code == 200) {
          this.openid = res.data;
        }
      });
    },
    //查看协议
    showProtocol(type) {
      if (type == 1) {
        MessageBox({
          title: "《企业服务代办服务协议》",
          message:
            "<div style='height:250px;overflow: auto;line-height:22px;text-align: justify;color:#000000;'>" +
            "<div style='text-indent: 2em;margin-top:5px;'><span style='color:red'>纽必企服企业服务代办助手</span>（以下简称“本平台”），是由<span style='color:red'>纽必文化传播（河北）有限公司</span>开发和运营的企业服务代办平台，主要为经营主体提供年报代办（当前年度年报代办和超过法律规定期限后的年报补报）、经营异常移出、注销等服务。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>我们郑重提示您，请您在申请注册同意本协议之前，认真阅读本协议和充分理解全部协议条款内容，<span style='font-weight: bolder;'>特别是其中涉及的免除或者限制我们义务与责任的条款、排除或者限制用户权利的条款等，以及以粗体字样标识的内容。</span>您知悉当您注册为纽必企服企业服务代办助手并支付年报代办、经营异常移出、注销费用，即表示您已充分阅读并理解和接受本协议的全部内容。并表示您全权委托本平台为您办理年报代办、经营异常移出、注销事宜，本平台将通过网络在线方式为您提供年报代办、经营异常移出、注销服务。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>本协议由您与本平台双方共同缔结，协议对您和本平台双方均有同等效力，本协议仅对与平台就办理年报代办报送、经营异常移出、注销事宜所签署协议文件的付费用户具有法律约束力。当前互联网高速发展，当前约定如不能保证完全符合未来，所以《隐私政策》等相关协议及规则规范均对本协议做补充协议，具有同等法律效力，若您付费使用本平台提供的年报代办、经营异常移出、注销服务，将视您同意以上补充说明。<span style='font-weight: bolder;'>如您不同意本协议，请立即停止注册或使用我们的服务。</span></div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>一、您知悉，按照《企业信息公示暂行条例》、《个体工商户年度报告暂行办法》等法规文件，报送工商年报是您的法定义务。您也知悉，通过市场监督管理部门渠道报送工商年报、补充报送年报、经营异常移出、注销是免费的。通过本平台进行企业年报代办、经营异常移出、注销服务是需要您向我司支付代办服务费用（代办服务费用金额以本平台向您公示的价格为准）。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>二、在您支付本平台年报代办、经营异常移出、注销服务费用后，表示您全权委托我司代理您办理年报报送、经营异常移出、注销事宜，也知道我司将通过在网络在线方式为您提供年报代办、经营异常移出、注销服务，在办理服务之前，您需要向我司提供年报报送、经营异常移出、注销需要但不限于法定代表人或者负责人身份证、手机号、经营状况等资料，您应当保证资料的真实性、完整性、合法性。我司依据本协议将根据您的委托，按照您企业（含个体户）管辖地市场监督管理部门的规定，及时为您办理代办服务。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>三、您提交年报报送、经营异常移出、注销资料后，我司将在30个工作日内完成年报（当前年度年报代办和超过法律规定期限后的年报补报）代报、经营异常移出、注销服务，年报代办、经营异常移出、注销成功的标准是您企业年报信息、经营异常状态移出、主体登记状态在“全国企业信用信息公示系统”中公示或在辖区市场监管部门网站公示。如在30个工作日内未能年报代报、经营异常移出、注销成功，我司将根据您的要求做退款或者继续办理。如若您最终要求退款，我司将在要求退款后的3个工作日完成退款，如要求继续办理则表示您不再追究我司在承诺时间内未能完结服务的任何责任。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>四、若出现不可抗力因素导致本协议的履行或者相关服务延后等情况，您不会让我司承担不可抗力因素而引起本协议履行问题的责任，不可抗因素包括但不限于：1.因政府管制而造成的临时性关闭、服务调整等；2.因基础运营商、服务商或主管部门故障、调整导致的影响；3.因大自然灾害灾难、战争、暴乱、司法行政命令、疫情等不可抗力因素；4.因常规或者紧急的设备或系统维修、设备与系统故障、数据安全完善等。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>五、服务终止后，您与我司双方将不再受本协议法律约束，服务终止情形如：1.年报代办服务、经营异常移出、注销完结；2.您要求退款，我司向您退款；3.您明确表示不接受我司因变更服务内容。符合以上终止情形，即意味着您与我司委托年报代办、经营异常移出、注销关系终止，本协议提及的法律约束也随即终止。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>六、我司为您提供了线上线下的服务咨询通道和服务通知，您除了可以通过纽必企服企业服务代办助手提供的线上咨询方式外，我司还为您提供了人工电话服务，服务电话：400-056-5663，您可在（工作日上午08：00-20：00）通过该电话咨询业务、了解服务进度、反馈服务问题、进行投诉、异议等，我司对于您的咨询会及时进行处理。此外，我司对于服务进度会对您通过书面形式进行实时通知，通知的形式包括但不限于电子邮件、手机短信、微信信息、电话沟通（根据您注册或者预留的任一联系方式）。为了能更好的服务，希望您能关注相关服务通知。我司在受理您的年报代办、经营异常移出、注销委托后，将会忠实履行相关代理义务，如您在年报代办服务、经营异常移出、注销过程中有任何异议，您都可以通过以上联系方式与我司联系。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>七、我司承诺，对于您提交的资料（凡年报代办、经营异常移出、注销服务成功的，您所提交的年报申报、经营异常移出、注销资料会保存到下一个年度的年报报送、经营异常移出、注销截止日，如果您选择的是“不公开”，我司将不保存；如年报代办、经营异常移出、注销服务未成功或者您终止了代办委托关系，我司仅保存您的联系方式），我司将采取严格的保密措施，且相关材料仅用于办理您委托的年报代办、经营异常移出、注销事宜，未经您的同意，我司承诺不向任何第三方公开、提供和发布，所保存的联系方式也仅用于与您本人联系。上述约定如是因我司违背，所引发的一切后果由我司承担。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>八、在年报代办服务、经营异常移出、注销期间，若我司未违背本协议约定，您不得向任何第三方发布、提供有损我司利益、形象、名誉的任何信息（包含但不限于我司开发的服务页面、服务流程等），否则我司有权追究您的法律责任。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;font-weight: bolder;'>九、免责声明：除法律法规有明确规定外，我们将尽最大努力确保纽必企服企业服务代办助手及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术，您理解我们不能对此进行担保。我们的服务是按照现有技术和条件所能达到的现状提供的。我们会尽最大努力向您提供服务，确保服务的连贯性和安全性；但我们不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范技术以及其他风险可能导致的服务中断、数据丢失以及其他的损失和风险。即使我们提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为我们违约，除法律另有强制性规定外，我们不对您因此受到的损失承担责任。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>十、如果在年报代办服务、经营异常移出、注销过程中，您与我司产生服务纠纷或者任何争议，双方应尽力友好协商解决，双方协商无果的，可向协议签订的有管辖权的人民法院提起诉讼，本协议签订地为保定市莲池区。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>十一、您在注册纽必企服企业服务代办助手并接受服务时，应该向我们提供真实有效的联系方式（包括您的联系电话），对于联系方式发生变更的，您有义务及时更新有关信息，并保持联系方式畅通。我们将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。我们向您浏览界面推送的弹窗等通知形式，也作为向您发出的有效通知。您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使通知无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>十二、您使用纽必企服企业服务代办助手或服务即视为您已阅读本协议并接受本协议的约束。我们有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用我们提供的软件或服务，即视为您已接受变更后的协议。</div>" +
            "</div>",
        });
      } else {
        MessageBox({
          title: "《隐私说明》",
          message:
            "<div style='height:250px;overflow: auto;line-height:22px;text-align: justify;color:#000000;'>" +
            "<div style='text-indent: 2em;margin-top:5px;'>尊敬的用户，首先感谢您对我们的信任，我们深知个人信息对您的重要性，确保您的数据安全和隐私保护是我们重要的任务。我们将按照法律法规要求，尽力保护您的个人信息安全可控。在您使用或支付服务费用前，请您务必审慎阅读并充分、透彻理解本隐私协议的全部内容和要点，<span style='font-weight: bolder;'>特别应重点阅读我们以粗体/下划线标识的条款，</span>确保您充分理解和同意后再开始使用。<span style='font-weight: bolder;'>一旦您使用或者继续支付费用，即表示您同意本隐私政策的全部内容，同意我们按照本协议处理您的个人信息。</span>如果您对本隐私政策内容有任何疑问、建议或意见，请通过本平台服务页面提供的在线客服或客服电话<span style='color: red;'>（400-056-5663）</span>联系我们，<span style='font-weight: bolder;'>对于您不同意本隐私协议的相关内容或条款，您应该停止使用我们提供的产品和服务，并避免在未与我们联系的情况下提供任何个人信息。</span></div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>一、我们如何收集和使用您的个人信息，为了更好的向您提供产品或服务，您需要向我们授权收集和使用您必要的个人信息，若您未提供服务所必要的相关信息，将导致您无法享受我们给您提供的产品或服务。为了给您提供更好的服务，我们将收集和使用您的如下个人信息，帮助您使用本系统，我们需要您提供包括但不限于联系方式（如联系电话、联系邮箱等），用于系统的登录。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>您知悉并同意对于您提供的个人信息（包括但不限于联系方式），我们可能会用于您支付购买的服务完成，如年报代办服务所涉及的年报信息填报、各类服务进度、服务推荐的通知，因此我们可能会自行或者委托第三方通过一种形式或者多种形式向您推送信息，方式主要以短信、电话方式，具体发送形式、频次以我们实际提供为准。如果您不愿接受以上信息通知，您可通过信息中提及的方式进行退订或者直接与我们联系进行退订。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;font-weight:bolder;'>如果我们要将您的个人信息用于本政策未载明的其他用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>二、我们如何存储与保护您的个人信息，我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内，且仅会在实现服务完成收集所需的时间内存储您的个人信息，在服务完成后（服务所对应的时间和要求）、在您主动终止服务或主动要求删除信息时，我们会尽快的删除您的个人信息。我们会确保依据本政策以及相关法律规定对您的个人信息提供足够的保护。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>我们将会用符合行业标准的安全防护措施保护您提供的个人信息，并对其中关键数据做加密处理，防止个人信息在未经授权的访问、使用、丢失、修改、公开披露或损坏。为了更好的保护您的个人信息，我们会采取一切合理可行的措施，将接触您个人信息的范围降低到最小范围。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>三、我们如何共享、公开披露、转让您的个人信息，我们不会与我们之外的任何第三方组织、个人或者公司共享、转让您的个人信息。如果确实存在必须共享、转让您的个人信息时，我们应当确认第三方组织、个人或者公司已经征得了您的同意，并严格要求第三方对您的个人信息进行保密且使用完成后进行删除。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>我们重视个人信息的安全与保护，我们承诺不会公开披露您的个人信息，如必须时，我们会向您书面告知公开披露的信息详情与原因，并需要征得您的同意。如您希望将您的个人信息转移至您指定的其他个人信息处理者，如您的请求符合法律规定的条件，我们将协助您进行转移。您可以本政策载明的方式联系我们以行使上述权利。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>共享、转让、公开披露个人信息时会有例外，以下情形中，公开披露您的个人信息无需事先征得您的授权同意：</div>" +
            "<div style='margin-top:5px;'>（1）您自行向社会公众公开的个人信息；</div>" +
            "<div style='margin-top:5px;'>（2）与国家安全、国防安全直接相关的；</div>" +
            "<div style='margin-top:5px;'>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>" +
            "<div style='margin-top:5px;'>（4）根据个人信息主体履行法律法规规定的义务、维护其享受产品或者服务权力所必需的；</div>" +
            "<div style='margin-top:5px;'>（5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>" +
            "<div style='margin-top:5px;'>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</div>" +
            "<div style='margin-top:5px;'>（7）国家法律法规规定的其他情形；</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>四、个人信息主体注销账户 ，（1）您可以通过本政策载明的方式联系我们的客服申请账户注销。（2）在您注销账户之后，我们将停止为您提供产品或服务。您曾通过该账户使用的我们的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>五、对本政策解释说明，如您对本政策的内容存在疑虑，您有权随时通过本政策公开的联系方式要求我们对本政策的相关内容进行解释说明。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>六、响应您的请求，（1）为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，再行处理您的请求。（2）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>七、我们如何处理儿童的个人信息，我们的产品、网站和服务为商用服务与产品，主要面向企业用户，一般不会向未成年人提供服务。如果我们发现自己在未事先获得未成年监护人同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关信息。</div>" +
            "<div style='text-indent: 2em;margin-top:5px;'>八、如何联系我们，如果您对本个人信息保护政策有任何疑问、意见或建议，请通过以下方式与我们联系，一般情况下，我们将在十五个工作日内回复。</div>" +
            "<div style='margin-top:5px;'>个人信息保护联系电话：<br>400-056-5663</div>" +
            "<div style='margin-top:5px;'>个人信息保护联系邮箱：<br>niubiqifu@163.com  </div>" +
            "</div>",
        });
      }
    },
  },
  created() {
    this.random = this.$route.query.state;
    // console.log(this.random)
    //查看是否为微信内置浏览器打开，有code截取code
    if (this.isWeiXin()) {
      if (window.location.search.indexOf("code") != -1) {
        let code = this.getQueryString("code");
        this.get_openid(code);
      } else {
        window.location.href = "https://" + window.location.host + `/${this.random}`;
      }
    }
    //获取公司信息
    this.get_company();
    this.judgeClient();
  },
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
/* by wdl */
.payment {
  .selectRadio,
  .selectRadio2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selectRadio::after {
    content: "";
    width: calc(100% - 3px);
    height: calc(100% - 3px);
    border-radius: 50%;
    // position: absolute;
    // top: 1.5px;
    // left: 1.5px;
    background: #116bff;
  }

  .selectRadio2::after {
    content: "";
    width: calc(100% - 3px);
    height: calc(100% - 3px);
    border-radius: 50%;
    position: absolute;
    top: 1.5px;
    left: 1.5px;
    background: #df1a1a;
  }

  background: #ececec;

  .common {
    background: #fff;
    box-shadow: 0px 2px 5px 0px #a7d7fb;
    width: 346px;
    margin: 10px auto 0;
    box-sizing: border-box;
  }

  .promptBox {
    padding: 9px 10px 15px;
    margin-top: 10px;
  }

  .pay {
    .title {
      padding-top: 11px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .rightBack,
      .leftBack {
        display: inline-block;
        width: 16px;
        height: 34px;
        background: #116bff;
      }

      .text {
        font-size: 19px;
        color: #df1a1a;
        font-weight: bolder;
        white-space: nowrap;
        letter-spacing: 1px;
      }
    }

    .prompt {
      text-align: center;
      font-weight: bold;
      background: #a7d7fb;
      margin: 20px 15px 15px;
      height: 10px;
      line-height: 0px;
      font-size: 14px;

      span:nth-of-type(2) {
        color: #df1a1a;
      }
    }

    .select {
      .xinzeng617Box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;

        .leftImg {
          width: 15px;
          height: 16px;
          background-image: url("../assets/images/huizhang.png");
          background-size: 100% 100%;
          margin-right: 6px;
        }

        .font {
          font-family: Source Han Sans SC;
          font-weight: bold;
          font-size: 17px;
          letter-spacing: 2px;
          color: #000000;
        }

        .rightImg {
          width: 15px;
          height: 16px;
          background-image: url("../assets/images/huizhang.png");
          background-size: 100% 100%;
          margin-left: 6px;
        }
      }

      .xinzeng617Box3 {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto 0px;
        width: 285px;
        height: 40px;

        .xinzeng617Box3_xian {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          z-index: -1;
          top: 9px;
          width: 85%;
          height: 2px;
          background-color: #b9d2fd;
        }

        .xinzeng617Box3_1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 52px;
          height: 100%;

          .xinzeng617Box3_1_top {
            width: 16px;
            height: 16px;
            background: #116bff;
            border-radius: 50%;
            text-align: center;
            font-size: 11px;
            line-height: 16px;
            color: white;
          }

          .xinzeng617Box3_1_bottom {
            margin-top: 5px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 12px;
            color: #3c3c3c;
          }
        }
      }

      .xinzeng617Box2 {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 12px;

        .xinzeng617Box2_yinying {
          position: absolute;
          bottom: 7px;
          left: 56px;
          width: 91px;
          height: 8px;
        }

        .xinzeng617Box2Left {
          display: flex;
          width: 175px;
          box-sizing: border-box;
          padding: 8px;
          font-size: 14px;
          font-weight: 900;
          border-radius: 10px;
          border: 1px solid #448bff;

          .xinzeng617Box2Left_font1 {
            width: 77px;
          }
        }

        .xinzeng617Box2right {
          width: 115px;
          height: 116px;
          background-image: url("../assets/images/ren.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position-y: 4px;
        }
      }

      .xinzeng617Box4 {
        box-sizing: border-box;
        width: 297px;
        margin: 0px auto 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: justify;

        .xinzeng617Box4_font {
          font-family: Source Han Sans SC;
          font-weight: bold;
          font-size: 17px;
          color: #000000;
        }

        .xinzeng617Box4_box {
          padding: 8px 12px 11px 0px;
          width: 200px;
          border-radius: 4px;
          font-family: Source Han Sans SC;
          font-size: 17px;
          font-weight: bold;
          text-decoration: underline;
          text-underline-offset: 5px;
          line-height: 25px;
          // color: #000000;
          color: #116bff;
        }
      }

      border: 1px solid #448bff;
      padding: 15px 0;
      border-radius: 8px;

      .price {
        box-sizing: border-box;
        margin: 0 auto;
        width: 297px;
        height: 47px;
        line-height: 47px;
        border-radius: 4px;

        .option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          font-weight: bolder;
          color: #df1a1a;
          font-size: 16px;

          .left {
            padding: 8px;
            border: 1px solid #df1a1a;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 80%;
            box-shadow: 0px 0px 5px 0px #888888;

            .howMuch {
              display: flex;
              align-items: center;

              .originalPrice {
                margin-right: 3px;
                text-decoration: line-through;
                color: #f89191;
              }
            }
          }

          .right {
            width: 20px;
            height: 20px;
            border: 1px solid #df1a1a;
            border-radius: 50%;
          }
        }

        .optionNo {
          color: #9e9c9c;

          .left {
            border: 1px solid #9e9c9c;

            .howMuch {
              .originalPrice {
                color: #9e9c9c;
              }
            }
          }

          .right {
            border: 1px solid #9e9c9c;
          }
        }

        .totalPrice {
          display: flex;
          align-items: center;

          .red {
            font-family: Source Han Sans SC;
            font-weight: bold;
            font-size: 17px;
            color: #000000;
            margin-right: 5px;
          }

          .grey {
            font-family: Source Han Sans SC;
            font-size: 12px;
            color: #686767;
            font-weight: bold;
          }
        }
      }

      .methods {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        margin-top: 12px;
        font-size: 15px;
        font-weight: bolder;

        .text {
          font-size: 15px;
        }

        img {
          width: 19px;
          height: 19px;
          margin-right: 5px;
        }

        .wxzfb {
          display: flex;
          align-items: center;
        }

        .wx,
        .zfb {
          display: flex;
          align-items: center;

          .radio {
            width: 15px;
            height: 15px;
            border: 1px solid #116bff;
            border-radius: 50%;
            margin-left: 5px;
          }
        }

        .wx {
          margin-right: 55px;
        }
      }

      .btn {
        width: 220px;
        height: 60px;
        background: url("../assets/images/btn617.png");
        background-size: 100% 100%;
        margin: 15px auto 0;

        .btn_font {
          font-family: Source Han Sans SC;
          font-weight: bolder;
          font-size: 17px;
          color: #ffffff;
          text-align: center;
          line-height: 52px;
        }
      }

      .agreement {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;

        .radio {
          width: 12px;
          height: 12px;
          border: 1px solid #116bff;
          border-radius: 50%;
          margin-right: 5px;
        }

        .text {
          span:nth-of-type(2),
          span:nth-of-type(4) {
            color: #116bff;
          }
        }
      }
    }
  }

  .enjoy {
    padding-top: 11px;
    margin-bottom: 10px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .rightBack,
      .leftBack {
        display: block;
        width: 22px;
        height: 34px;
        background: #116bff;
      }

      .text {
        font-size: 20px;
        color: #df1a1a;
        font-weight: bolder;
      }

      .leftBack {
        transform: rotate(180deg);
      }
    }

    .differenceBox {
      padding: 9px;
    }

    .difference {
      display: flex;
      border-radius: 10px;
      overflow: hidden;
      margin-top: 10px;
      font-size: 12px;
      font-weight: bold;

      .left,
      .right {
        width: 50%;
        padding: 10px 10px 20px;
        box-sizing: border-box;

        .title2 {
          text-align: center;
          font-size: 17px;
          font-weight: bolder;
        }

        .benefits,
        .harm {
          margin-top: 5px;

          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }

          div {
            display: flex;
            align-items: center;
            line-height: 24px;
            height: 60px;
          }
        }
      }

      .left {
        background: #116bff;
        color: #fff;
      }

      .right {
        background: #b9d2fd;
        color: #707070;
      }
    }
  }
}
</style>
